import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {withFormsy} from 'formsy-react';
import styles from './Checkbox.pcss';
import {Icon} from 'epic-diesel-common';
import {sizes, svgs} from 'epic-diesel-common/src/constants';

class CheckBox extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        children: PropTypes.object,
        className: PropTypes.string,
        getValue: PropTypes.func,
        onChange: PropTypes.func,
        //setValue: PropTypes.func,
        showError: PropTypes.func,
        isPristine: PropTypes.func,
        getErrorMessage: PropTypes.func
    };

    static defaultProps = {
        className: ''
    };

    onClick = event => {
        if (this.props.onChange) {
            const value = !this.props.getValue();
            this.props.onChange(this.props.name, value);
        }
    };

    render() {
        const {
            name,
            children,
            className,
            getValue,
            isPristine,
            showError,
            getErrorMessage
        } = this.props;

        const isError = !isPristine() && showError();

        const wrapperClasses = cx(
            styles.wrapper,
            className,
            {[styles.isChecked]: getValue()} // assuming this is a boolean
        );

        return (
            <div className={wrapperClasses} name={name} onClick={this.onClick}>
                <Icon icon={svgs.UNCHECKED} className={styles.empty} size={sizes.XXSMALL} />
                <Icon icon={svgs.CHECKED} className={styles.checked} size={sizes.XXSMALL} />
                <div className={styles.checkboxContainer}>{children}</div>
                {isError && <div className={styles.error}>{getErrorMessage()}</div>}
            </div>
        );
    }
}

export default withFormsy(CheckBox);
